import styled from 'styled-components'

export const StepContent = styled.div`
  min-height: 300px;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Heading = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
`

export const Instruction = styled.div`
  font-size: 12.8px;
  text-align: center;
  margin-bottom: 1.5rem;
`

export const ParagraphForm = styled.div`
  margin-bottom: 40px;
`

export const FormParagraph = styled.div`
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 32px;
  color: #2c3e50;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`
